import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { CalendarEvent, CalendarView, DAYS_OF_WEEK } from 'angular-calendar';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { EventDto } from './eventDto';
import { CalendarService } from './calendar.service';
import { Subject } from 'rxjs';
import { MessageFeedDto } from './messageFeedDto';
import { ChangeDetectorRef } from '@angular/core';
import { MessageFeedDialogService } from '../message-feed-dialog/message.feed.service';
import { MessageFeedDialogComponent } from '../message-feed-dialog/message-feed-dialog.component';
import { ThrowStmt } from '@angular/compiler';

const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  green: {
    primary: '#00ff44',
    secondary: '#008022',
  },
};

@Component({
  selector: 'app-calendar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
})
export class CalendarComponent implements OnInit {
  viewDate: Date = new Date();
  view: CalendarView = CalendarView.Month;
  CalendarView = CalendarView;
  clickedDate!: Date;
  clickedColumn!: number;
  events: CalendarEvent[] = [];
  eventDtos: EventDto[] = [];
  weekStartsOn = DAYS_OF_WEEK.MONDAY;
  messageFeeds: MessageFeedDto[] = [];
  emoji = '&#x1F60A;';

  locale: string = 'hu';

  constructor(
    private router: Router,
    private datePipe: DatePipe,
    private calendarService: CalendarService,
    private CD: ChangeDetectorRef,
    private messageFeedDialogServce: MessageFeedDialogService
  ) {}

  refresh: Subject<any> = new Subject();

  ngOnInit(): void {
    this.calendarService.getEvents().subscribe((events) => {
      this.eventDtos = events;
      this.fillEvents();
      this.refresh.next();
    });
    this.calendarService.getMessageFeeds().subscribe((messages) => {
      this.messageFeeds = messages;
    });
  }

  navigateToDayPage(date: Date): void {
    const urlParam = this.datePipe.transform(date, 'yyyy-MM-dd');
    console.log(urlParam);
    this.router.navigate(['/day', urlParam]);
  }

  private fillEvents(): void {
    for (var eventDto of this.eventDtos) {
      this.createEvent(eventDto.date, eventDto.customer, eventDto.solved);
    }
  }

  private createEvent(date: string, customer: string, solved: boolean) {
    var color;
    if (solved) {
      color = colors.green;
    } else {
      color = colors.red;
    }
    this.events = [
      ...this.events,
      {
        start: new Date(date),
        title: customer,
        color: color,
      },
    ];
  }

  createMessageFeed(): void {
    this.messageFeedDialogServce
      .open()
      .then(() => {
        this.calendarService.getMessageFeeds().subscribe((messageFeeds) => {
          this.messageFeeds = messageFeeds;
          this.CD.detectChanges();
        });
      })
  }

  deleteMessageFeed(id: string): void {
    this.calendarService.deleteMessageFeed(id).subscribe(() => {
      this.calendarService.getMessageFeeds().subscribe((messageFeeds) => {
        this.messageFeeds = messageFeeds;
        this.CD.detectChanges();
      });
    });
  }
}
